export default {
    paises: [
      { value: 'Afganistán', text: 'Afganistán' },
      { value: 'Albania', text: 'Albania' },
      { value: 'Alemania', text: 'Alemania' },
      { value: 'Andorra', text: 'Andorra' },
      { value: 'Angola', text: 'Angola' },
      { value: 'Antigua y Barbuda', text: 'Antigua y Barbuda' },
      { value: 'Arabia Saudita', text: 'Arabia Saudita' },
      { value: 'Argelia', text: 'Argelia' },
      { value: 'Argentina', text: 'Argentina' },
      { value: 'Armenia', text: 'Armenia' },
      { value: 'Australia', text: 'Australia' },
      { value: 'Austria', text: 'Austria' },
      { value: 'Azerbaiyán', text: 'Azerbaiyán' },
      { value: 'Bahamas', text: 'Bahamas' },
      { value: 'Bangladés', text: 'Bangladés' },
      { value: 'Barbados', text: 'Barbados' },
      { value: 'Baréin', text: 'Baréin' },
      { value: 'Bélgica', text: 'Bélgica' },
      { value: 'Belice', text: 'Belice' },
      { value: 'Benín', text: 'Benín' },
      { value: 'Bielorrusia', text: 'Bielorrusia' },
      { value: 'Birmania', text: 'Birmania' },
      { value: 'Bolivia', text: 'Bolivia' },
      { value: 'Bosnia y Herzegovina', text: 'Bosnia y Herzegovina' },
      { value: 'Botsuana', text: 'Botsuana' },
      { value: 'Brasil', text: 'Brasil' },
      { value: 'Brunéi', text: 'Brunéi' },
      { value: 'Bulgaria', text: 'Bulgaria' },
      { value: 'Burkina Faso', text: 'Burkina Faso' },
      { value: 'Burundi', text: 'Burundi' },
      { value: 'Bután', text: 'Bután' },
      { value: 'Cabo Verde', text: 'Cabo Verde' },
      { value: 'Camboya', text: 'Camboya' },
      { value: 'Camerún', text: 'Camerún' },
      { value: 'Canadá', text: 'Canadá' },
      { value: 'Catar', text: 'Catar' },
      { value: 'Chad', text: 'Chad' },
      { value: 'Chile', text: 'Chile' },
      { value: 'China', text: 'China' },
      { value: 'Chipre', text: 'Chipre' },
      { value: 'Ciudad del Vaticano', text: 'Ciudad del Vaticano' },
      { value: 'Colombia', text: 'Colombia' },
      { value: 'Comoras', text: 'Comoras' },
      { value: 'Corea del Norte', text: 'Corea del Norte' },
      { value: 'Corea del Sur', text: 'Corea del Sur' },
      { value: 'Costa de Marfil', text: 'Costa de Marfil' },
      { value: 'Costa Rica', text: 'Costa Rica' },
      { value: 'Croacia', text: 'Croacia' },
      { value: 'Cuba', text: 'Cuba' },
      { value: 'Dinamarca', text: 'Dinamarca' },
      { value: 'Dominica', text: 'Dominica' },
      { value: 'Ecuador', text: 'Ecuador' },
      { value: 'Egipto', text: 'Egipto' },
      { value: 'El Salvador', text: 'El Salvador' },
      { value: 'Emiratos Árabes Unidos', text: 'Emiratos Árabes Unidos' },
      { value: 'Eritrea', text: 'Eritrea' },
      { value: 'Eslovaquia', text: 'Eslovaquia' },
      { value: 'Eslovenia', text: 'Eslovenia' },
      { value: 'España', text: 'España' },
      { value: 'Estados Unidos', text: 'Estados Unidos' },
      { value: 'Estonia', text: 'Estonia' },
      { value: 'Etiopía', text: 'Etiopía' },
      { value: 'Filipinas', text: 'Filipinas' },
      { value: 'Finlandia', text: 'Finlandia' },
      { value: 'Fiyi', text: 'Fiyi' },
      { value: 'Francia', text: 'Francia' },
      { value: 'Gabón', text: 'Gabón' },
      { value: 'Gambia', text: 'Gambia' },
      { value: 'Georgia', text: 'Georgia' },
      { value: 'Ghana', text: 'Ghana' },
      { value: 'Granada', text: 'Granada' },
      { value: 'Grecia', text: 'Grecia' },
      { value: 'Guatemala', text: 'Guatemala' },
      { value: 'Guinea', text: 'Guinea' },
      { value: 'Guinea-Bisáu', text: 'Guinea-Bisáu' },
      { value: 'Guinea Ecuatorial', text: 'Guinea Ecuatorial' },
      { value: 'Guyana', text: 'Guyana' },
      { value: 'Haití', text: 'Haití' },
      { value: 'Honduras', text: 'Honduras' },
      { value: 'Hungría', text: 'Hungría' },
      { value: 'India', text: 'India' },
      { value: 'Indonesia', text: 'Indonesia' },
      { value: 'Irak', text: 'Irak' },
      { value: 'Irán', text: 'Irán' },
      { value: 'Irlanda', text: 'Irlanda' },
      { value: 'Islandia', text: 'Islandia' },
      { value: 'Islas Marshall', text: 'Islas Marshall' },
      { value: 'Islas Salomón', text: 'Islas Salomón' },
      { value: 'Israel', text: 'Israel' },
      { value: 'Italia', text: 'Italia' },
      { value: 'Jamaica', text: 'Jamaica' },
      { value: 'Japón', text: 'Japón' },
      { value: 'Jordania', text: 'Jordania' },
      { value: 'Kazajistán', text: 'Kazajistán' },
      { value: 'Kenia', text: 'Kenia' },
      { value: 'Kirguistán', text: 'Kirguistán' },
      { value: 'Kiribati', text: 'Kiribati' },
      { value: 'Kuwait', text: 'Kuwait' },
      { value: 'Laos', text: 'Laos' },
      { value: 'Lesoto', text: 'Lesoto' },
      { value: 'Letonia', text: 'Letonia' },
      { value: 'Líbano', text: 'Líbano' },
      { value: 'Liberia', text: 'Liberia' },
      { value: 'Libia', text: 'Libia' },
      { value: 'Liechtenstein', text: 'Liechtenstein' },
      { value: 'Lituania', text: 'Lituania' },
      { value: 'Luxemburgo', text: 'Luxemburgo' },
      { value: 'Madagascar', text: 'Madagascar' },
      { value: 'Malasia', text: 'Malasia' },
      { value: 'Malaui', text: 'Malaui' },
      { value: 'Maldivas', text: 'Maldivas' },
      { value: 'Malí', text: 'Malí' },
      { value: 'Malta', text: 'Malta' },
      { value: 'Marruecos', text: 'Marruecos' },
      { value: 'Mauricio', text: 'Mauricio' },
      { value: 'Mauritania', text: 'Mauritania' },
      { value: 'México', text: 'México' },
      { value: 'Micronesia', text: 'Micronesia' },
      { value: 'Moldavia', text: 'Moldavia' },
      { value: 'Mónaco', text: 'Mónaco' },
      { value: 'Mongolia', text: 'Mongolia' },
      { value: 'Montenegro', text: 'Montenegro' },
      { value: 'Mozambique', text: 'Mozambique' },
      { value: 'Namibia', text: 'Namibia' },
      { value: 'Nauru', text: 'Nauru' },
      { value: 'Nepal', text: 'Nepal' },
      { value: 'Nicaragua', text: 'Nicaragua' },
      { value: 'Níger', text: 'Níger' },
      { value: 'Nigeria', text: 'Nigeria' },
      { value: 'Noruega', text: 'Noruega' },
      { value: 'Nueva Zelanda', text: 'Nueva Zelanda' },
      { value: 'Omán', text: 'Omán' },
      { value: 'Países Bajos', text: 'Países Bajos' },
      { value: 'Pakistán', text: 'Pakistán' },
      { value: 'Palaos', text: 'Palaos' },
      { value: 'Panamá', text: 'Panamá' },
      { value: 'Papúa Nueva Guinea', text: 'Papúa Nueva Guinea' },
      { value: 'Paraguay', text: 'Paraguay' },
      { value: 'Perú', text: 'Perú' },
      { value: 'Polonia', text: 'Polonia' },
      { value: 'Portugal', text: 'Portugal' },
      { value: 'Reino Unido', text: 'Reino Unido' },
      { value: 'República Centroafricana', text: 'República Centroafricana' },
      { value: 'República Checa', text: 'República Checa' },
      { value: 'República del Congo', text: 'República del Congo' },
      { value: 'República Democrática del Congo', text: 'República Democrática del Congo' },
      { value: 'República Dominicana', text: 'República Dominicana' },
      { value: 'República Sudafricana', text: 'República Sudafricana' },
      { value: 'Ruanda', text: 'Ruanda' },
      { value: 'Rumanía', text: 'Rumanía' },
      { value: 'Rusia', text: 'Rusia' },
      { value: 'Samoa', text: 'Samoa' },
      { value: 'San Cristóbal y Nieves', text: 'San Cristóbal y Nieves' },
      { value: 'San Marino', text: 'San Marino' },
      { value: 'San Vicente y las Granadinas', text: 'San Vicente y las Granadinas' },
      { value: 'Santa Lucía', text: 'Santa Lucía' },
      { value: 'Santo Tomé y Príncipe', text: 'Santo Tomé y Príncipe' },
      { value: 'Senegal', text: 'Senegal' },
      { value: 'Serbia', text: 'Serbia' },
      { value: 'Seychelles', text: 'Seychelles' },
      { value: 'Sierra Leona', text: 'Sierra Leona' },
      { value: 'Singapur', text: 'Singapur' },
      { value: 'Siria', text: 'Siria' },
      { value: 'Somalia', text: 'Somalia' },
      { value: 'Sri Lanka', text: 'Sri Lanka' },
      { value: 'Suazilandia', text: 'Suazilandia' },
      { value: 'Sudán', text: 'Sudán' },
      { value: 'Sudán del Sur', text: 'Sudán del Sur' },
      { value: 'Suecia', text: 'Suecia' },
      { value: 'Suiza', text: 'Suiza' },
      { value: 'Surinam', text: 'Surinam' },
      { value: 'Tailandia', text: 'Tailandia' },
      { value: 'Tanzania', text: 'Tanzania' },
      { value: 'Tayikistán', text: 'Tayikistán' },
      { value: 'Timor Oriental', text: 'Timor Oriental' },
      { value: 'Togo', text: 'Togo' },
      { value: 'Tonga', text: 'Tonga' },
      { value: 'Trinidad y Tobago', text: 'Trinidad y Tobago' },
      { value: 'Túnez', text: 'Túnez' },
      { value: 'Turkmenistán', text: 'Turkmenistán' },
      { value: 'Turquía', text: 'Turquía' },
      { value: 'Tuvalu', text: 'Tuvalu' },
      { value: 'Ucrania', text: 'Ucrania' },
      { value: 'Uganda', text: 'Uganda' },
      { value: 'Uruguay', text: 'Uruguay' },
      { value: 'Uzbekistán', text: 'Uzbekistán' },
      { value: 'Vanuatu', text: 'Vanuatu' },
      { value: 'Venezuela', text: 'Venezuela' },
      { value: 'Vietnam', text: 'Vietnam' },
      { value: 'Yemen', text: 'Yemen' },
      { value: 'Yibuti', text: 'Yibuti' },
      { value: 'Zambia', text: 'Zambia' },
      { value: 'Zimbabue', text: 'Zimbabue' }
    ]
  };
  